import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './DecisionWheel.css'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const COLORS = ['#ff7a45', '#5eead4', '#fbbf24', '#4ade80', '#6c8eff', '#c084fc']
const DEFAULT_TEXT = 'Pizza\nSushi\nHambúrguer\nMassa\nSalada'

const DecisionWheel = () => {
  useDocumentMeta({
    title: 'Roleta de Decisão Online  jarder.dev',
    description:
      'Não sabe o que decidir? Coloque as opções e gire a roleta  ' +
      'grátis, direto no navegador, sem cadastro.',
  })

  const [text, setText] = useState(DEFAULT_TEXT)
  const [rotation, setRotation] = useState(0)
  const [spinning, setSpinning] = useState(false)
  const [winner, setWinner] = useState(null)
  const canvasRef = useRef(null)

  const options = text
    .split('\n')
    .map((o) => o.trim())
    .filter(Boolean)
  const optionsKey = options.join('|')

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas || options.length === 0) return
    const ctx = canvas.getContext('2d')
    const size = canvas.width
    const radius = size / 2
    const sliceAngle = (2 * Math.PI) / options.length

    ctx.clearRect(0, 0, size, size)
    options.forEach((option, i) => {
      const start = -Math.PI / 2 + i * sliceAngle
      const end = start + sliceAngle
      ctx.beginPath()
      ctx.moveTo(radius, radius)
      ctx.arc(radius, radius, radius - 4, start, end)
      ctx.closePath()
      ctx.fillStyle = COLORS[i % COLORS.length]
      ctx.fill()

      ctx.save()
      ctx.translate(radius, radius)
      ctx.rotate(start + sliceAngle / 2)
      ctx.textAlign = 'right'
      ctx.fillStyle = '#0b0d12'
      ctx.font = 'bold 16px "Hanken Grotesk", sans-serif'
      ctx.fillText(option.slice(0, 16), radius - 16, 6)
      ctx.restore()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optionsKey])

  const spin = () => {
    if (options.length < 2 || spinning) return
    const sliceAngleDeg = 360 / options.length
    const targetIndex = Math.floor(Math.random() * options.length)
    const targetCenterAngle = -90 + (targetIndex + 0.5) * sliceAngleDeg
    let delta = (270 - targetCenterAngle) % 360
    if (delta < 0) delta += 360
    const base = Math.ceil((rotation + 1) / 360) * 360
    const newRotation = base + 4 * 360 + delta

    setWinner(null)
    setSpinning(true)
    setRotation(newRotation)
    window.setTimeout(() => {
      setSpinning(false)
      setWinner(options[targetIndex])
      trackEvent('tool_generate', { tool: 'decision_wheel' })
    }, 4200)
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Roleta de Decisão</h1>
      <p className="tool-disclaimer">
        Cole suas opções (uma por linha) e gire a roleta.
      </p>

      <div className="tool-field">
        <label htmlFor="wheel-options">Opções (uma por linha)</label>
        <textarea
          id="wheel-options"
          rows="6"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </div>

      <div className="decision-wheel-stage">
        <div className="decision-wheel-pointer" />
        <canvas
          ref={canvasRef}
          width="320"
          height="320"
          className="decision-wheel-canvas"
          style={{ transform: `rotate(${rotation}deg)` }}
        />
      </div>

      <button
        type="button"
        className="tool-button"
        onClick={spin}
        disabled={options.length < 2 || spinning}
      >
        {spinning ? 'Girando...' : 'Girar'}
      </button>

      {winner && (
        <div className="tool-result-card" style={{ marginTop: 20 }}>
          <span className="tool-result-label">Resultado</span>
          <span className="tool-result-value">{winner}</span>
        </div>
      )}

      <div className="tool-info-section">
        <h2>Ideias de uso</h2>
        <p>
          Cole quantas opções quiser (o desenho se ajusta
          automaticamente): onde jantar, qual filme assistir, quem
          começa um jogo, sorteio de tarefas em equipe ou dinâmicas em
          sala de aula. O sorteio usa números aleatórios do navegador,
          então cada opção tem a mesma chance de ser escolhida.
        </p>
      </div>
    </div>
  )
}

export default DecisionWheel
